import { AvailabilityMethod } from 'generated-graphql/graphql';
import { isRoundRobinMethod } from './isRoundRobinMethod';

const ROUND_ROBIN_POOL_MIN = 2;
const ROUND_ROBIN_POOL_MAX = 10;

// Mirrors calendar-service's rule so the form fails before the API does.
export const validateParticipantsForMethod = (
  availabilityMethod: AvailabilityMethod | null | undefined,
  participants: readonly { isOrganizer?: boolean | null }[] | undefined,
  // The panel also lists members Popp can't reach, which saving removes and so
  // never count towards the pool. Without this the count contradicts the rows.
  unreachableCount = 0
): string | null => {
  const pool = participants ?? [];

  if (isRoundRobinMethod(availabilityMethod)) {
    if (pool.length < ROUND_ROBIN_POOL_MIN) {
      return unreachableCount > 0
        ? `Round robin needs at least ${ROUND_ROBIN_POOL_MIN} interviewers Popp can reach. Add another from the meeting panel.`
        : `Round robin needs at least ${ROUND_ROBIN_POOL_MIN} interviewers`;
    }

    return pool.length > ROUND_ROBIN_POOL_MAX
      ? `Round robin allows at most ${ROUND_ROBIN_POOL_MAX} interviewers`
      : null;
  }

  return pool.some((participant) => participant.isOrganizer)
    ? null
    : 'Mark one interviewer as the organiser';
};
